<template>
  <section class="ln">
    <div class="in_wrap">
      <h1 class="ln_tit"><strong>Latest</strong> News</h1>
      <div class="container swiper-container slide4">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="news in newsList" :key="news.newsId">
            <a href="" class="btn" @click.prevent="$emit('move-to-detail', news.newsId)">
              <div class="contents">
                <h2 class="item_tit">
                  {{news.title}}
                </h2>
                <p class="item_date">{{$moment(news.createDatetime).format('YYYY. MM. DD')}}</p>
                <div class="label">{{changeCRSNaming(news.newsType.text)}}</div>
              </div>
              <img :src="news.thumbnailImageUrl" class="img" alt="" />
            </a>
          </div>
        </div>
      </div>
      <a href="" class="btn-go" @click.prevent="$router.push('/news')">더보기</a>
    </div>
  </section>
</template>

<script>

export default {
  name: 'LatestNews',
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    changeCRSNaming(name) {
      if (name === 'CSR(사회공헌)') {
        return '사회공헌';
      }
      return name;
    },
  },
};
</script>

<style></style>
